<template>
  <div class="home">
    <div class="main">
      <div class="banner">
        <div class="block">
          <el-carousel id="id1" height="750px" :interval="interval">
            <el-carousel-item
              id="id2"
              v-for="(item, index) in urlImg"
              :key="index"
            >
              <img id="id3" v-lazy="item.urlLink" @click="bannerBtn(index)" />
            </el-carousel-item>
          </el-carousel>
        </div>

        <div class="home_box">
          <div class="banner_font">
            <div class="font_item">
              <div class="font_top">
                <span class="font_num city">5</span>
                <span>年</span>
              </div>
              <div class="font_bottom">品牌历程</div>
            </div>
            <div class="font_line"></div>
            <div class="font_item">
              <div class="font_top">
                <span>5城</span>
                <span class="font_num">16</span>
                <span>店</span>
              </div>
              <div class="font_bottom">风靡全国</div>
            </div>
            <div class="font_line"></div>
            <div class="font_item">
              <div class="font_top">
                <span class="font_num">156</span>
                <span>万+</span>
              </div>
              <div class="font_bottom">已服务人次</div>
            </div>
            <div class="font_line"></div>
            <div class="font_item">
              <div class="font_top">
                <span class="font_num">95</span>
                <span>%+</span>
              </div>
              <div class="font_bottom">已好评度</div>
            </div>
          </div>
        </div>
        <div class="serve">
          <div class="serve_top">
            <div class="serve_t_font">服务项目</div>
            <div class="serve_b_font">居家养老一站式服务</div>
          </div>
          <div class="serve_bottom">
            <div class="serve_b_img">
              <div>
                <img src="https://static-ssl.aijiehu.cn/serve1.png" alt="" />
              </div>
              <div>居家照顾</div>
              <div>被护理者大部分时间住在家里接受治疗和照护的方式</div>
            </div>
            <div class="serve_b_img">
              <div>
                <img src="https://static-ssl.aijiehu.cn/serve2.png" alt="" />
              </div>
              <div>长护险服务</div>
              <div>
                在丧失日常生活能力,年老患病或身故时，侧重于提供护理保障和经济补偿的保险产品
              </div>
            </div>
            <div class="serve_b_img">
              <div>
                <img src="https://static-ssl.aijiehu.cn/serve3.png" alt="" />
              </div>
              <div>医院陪护</div>
              <div>有专业医疗技能的在医院看护病人的护工</div>
            </div>
            <div class="serve_b_img">
              <div>
                <img src="https://static-ssl.aijiehu.cn/serve4.png" alt="" />
              </div>
              <div>老年餐定制</div>
              <div>为老年人定制适合的荤素搭配的营养餐</div>
            </div>
            <div class="serve_b_img">
              <div>
                <img src="https://static-ssl.aijiehu.cn/serve5.png" alt="" />
              </div>
              <div>居家钟点</div>
              <div>非全日工作的家庭服务人员</div>
            </div>
            <div class="serve_b_img">
              <div>
                <img src="https://static-ssl.aijiehu.cn/serve6.png" alt="" />
              </div>
              <div>适老化改造</div>
              <div>
                为适应中老年人而设计的适应老年人生理和心理需求的建筑以及室内空间环境
              </div>
            </div>
          </div>
        </div>
        <div class="home_audio">
          <div class="button_opcity" @click="play"></div>
          <div class="home_audio_font">
            <div>
              <span>爱介护</span>
              <span> —— 居家养老服务平台</span>
            </div>
            <div>
              <p>
                爱介护成立于2015年，始终致力于为社区居家长者提供方便，快捷，高质量，人性化的健康介护服务，并逐步成为国内居家养老行业独具特色的品牌和服务连锁机构。
              </p>
              <p>
                主要服务项目有长护险服务，健康管家，生活照料，医院陪护，乐养服务，老年餐定制配送，钟点服务，乐养服务以及适老化改造等。
              </p>
            </div>
            <div class="more">More>></div>
          </div>
        </div>
        <div class="advantage">
          <div class="advantage_title">
            <p>我们的优势</p>
            <p>
              爱介护以创新的商业模式，专业的护理技术以及健康管理乐养服务的发展理念为长者提供居家养老一站式解决方案！
            </p>
          </div>
          <div class="advantage_img1">
            <img src="../assets/images/advantage1.png" alt="" />
            <div class="adv_con1">
              <p>
                <img
                  src="../assets/images/apply3.png"
                  alt=""
                />完善的管理运营团队
              </p>
              <p>
                <img
                  src="../assets/images/apply3.png"
                  alt=""
                />拥有护理人员的培训中心
              </p>
            </div>
          </div>
          <div class="advantage_img2">
            <div class="adv_con">
              <p>
                <img
                  src="../assets/images/apply3.png"
                  alt=""
                />拥有医养一体化服务云平台
              </p>
              <p>
                <img src="../assets/images/apply3.png" alt="" />
                灵活多样的服务模式及24<br />
                &nbsp; &nbsp;小时保障服务
              </p>
              <!-- <p></p> -->
            </div>
            <img src="../assets/images/advantage2.png" alt="" />
          </div>
          <div class="branches">
            <div class="branches_title">我们的服务网点</div>
            <div class="branches_box">
              <div class="branches_img">
                <img src="https://static-ssl.aijiehu.cn/branch.png" alt="" />
              </div>

              <div class="branches_font">
                <Address></Address>
              </div>
            </div>
          </div>

          <div class="news">
            <p class="new_title">新闻资讯</p>
            <News class="news_com"></News>
            <p class="news_more">
              <router-link to="/newscenter">更多>></router-link>
            </p>
          </div>
          <!-- <div class="join">
            <span class="title1">合作伙伴</span>
            <div class="img1">
              <img src="../assets/images/partner1.png" />
              <img src="../assets/images/partner2.png" />
              <img src="../assets/images/partner3.png" />
              <img src="../assets/images/partner4.png" />
              <img src="../assets/images/partner5.png" />
            </div>
          </div> -->
          <div class="friends">
            <Friends></Friends>
          </div>
          <div class="footer">
            <!-- <Footer></Footer> -->
          </div>
          <Contact class="contact_box"></Contact>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Header from "@/components/Header.vue";
import News from "@/components/News.vue";
import Friends from "@/components/Friends.vue";
import Contact from "@/components/Contact.vue";
import Address from "@/components/Address.vue";

export default {
  name: "Home",
  data() {
    return {
      urlImg: [
        {
          urlLink: "https://static-ssl.aijiehu.cn/banner2.jpg"
        },
        {
          urlLink: "https://static-ssl.aijiehu.cn/banner.jpg"
        },
        {
          urlLink: "https://static-ssl.aijiehu.cn/banner2.jpg"
        },
        {
          urlLink: "https://static-ssl.aijiehu.cn/banner.jpg"
        }
      ],
      interval: 3000
    };
  },
  components: {
    News,
    Contact,
    Address,
    Friends
  },

  methods: {
    bannerBtn(i) {
      if (i % 2 == 0) {
        let routeUrl = this.$router.resolve({
          path: "./bannerlive"
        });
        window.open(routeUrl.href, "_blank");
      }
    },
    play() {
      window.open("https://www.bilibili.com/video/BV1NX4y137ub", "_blank");
    }
  }
};
</script>

<style scoped>
.home {
  font-family: "SourceHanSansCN";
  width: 100%;
}
.banner {
  width: 100%;
  /* height: 100%; */
}
.block {
  height: 750px;
  width: 100%;
}
.home_box {
  position: relative;
  display: flex;
  justify-content: center;
}
.banner_font {
  position: absolute;
  top: -115px;
  background: url(../assets/images/rectangle1.png) no-repeat;
  background-size: 1498px 268px;
  height: 268px;
  width: 1498px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  z-index: 999;
}
.font_line {
  height: 40%;
  border-right: 1px solid #ccc;
}
.font_top {
  color: #f29800;
  font-size: 20px;
}
.font_num {
  font-size: 48px;
  font-weight: bold;
}
.city {
  font-weight: bold;
}
.font_bottom {
  font-size: 18px;
  margin-top: 20px;
  color: #666;
}
.serve {
  margin-top: 240px;
}
.serve_t_font {
  color: #333333;
  font-size: 30px;
  font-weight: bold;
}
.serve_b_font {
  padding: 28px 0;
  color: #333;
  font-size: 22px;
}
.serve_bottom {
  width: 1520px;
  display: flex;
  justify-content: space-around;
  margin: auto;
  margin-top: 42px;
}
.serve_b_img {
  width: 223px;
}
.serve_b_img img {
  height: 170px;
  width: 223px;
}
.serve_b_img div:nth-child(2) {
  font-size: 22px;
  color: #333333;
  font-weight: bold;
  padding: 30px 0;
}
.serve_b_img div:nth-child(3) {
  font-size: 18px;
  color: #999999;
  line-height: 30px;
}
.home_audio {
  background: url(../assets/images/1.png) no-repeat;
  background-size: 100% 615px;
  height: 615px;
  width: 100%;
  margin-top: 100px;
  position: relative;
  overflow: hidden;
}
.button_opcity {
  height: 200px;
  width: 200px;
  background-color: pink;
  position: absolute;
  top: 200px;
  left: 440px;
  opacity: 0;
  cursor: pointer;
}
.home_audio_font {
  position: absolute;
  left: 1200px;
  width: 406px;
  color: #fff;
  top: 88px;
  overflow: hidden;
}
.home_audio_font > div {
  text-align: left;
}

.home_audio_font span:nth-child(1) {
  font-size: 30px;
  font-weight: bold;
}
.home_audio_font span:nth-child(2) {
  font-size: 24px;
  font-weight: bold;
}
.home_audio_font p {
  font-size: 20px;
  text-indent: 2em;
  text-align: left;
  line-height: 40px;
}
.home_audio_font p:nth-child(1) {
  padding-top: 30px;
}
.more {
  font-size: 20px;
  font-weight: bold;
  text-align: left;
  cursor: pointer;
  margin-top: 30px;
  padding-left: 4px;
}
.advantage {
  margin-top: 100px;
}
.advantage_title p:nth-child(1) {
  color: #333333;
  font-size: 30px;
  font-weight: bold;
}
.advantage_title p:nth-child(2) {
  margin-top: 28px;
  color: #333333;
  font-size: 22px;
}
.advantage_img1 {
  display: flex;
  justify-content: center;
  margin-top: 74px;
}
.advantage_img1 div {
  color: #f29800;
  font-size: 24px;
  text-align: left;
  line-height: 60px;
  font-weight: bold;
}
.advantage_img1 img {
  width: 46%;
  height: 6%;
  margin-right: 5%;
}
.advantage_img2 {
  display: flex;
  justify-content: center;
  margin-top: 60px;
}
.advantage_img2 img {
  width: 46%;
  height: 6%;
}
.advantage_img2 div {
  color: #f29800;
  font-size: 24px;
  text-align: left;
  line-height: 60px;
  margin-right: 4%;
  font-weight: bold;
}

.branches {
  margin-top: 100px;
}
.branches_title {
  color: #333333;
  font-size: 30px;
  font-weight: bold;
}
.branches_img img {
  height: 670px;
}
.branches_box {
  margin-top: 74px;
  height: 670px;
  position: relative;
}
.branches_font {
  position: absolute;
  top: 110px;
  right: 0;
  width: 46%;
  height: 450px;
  background-color: #f5ae37;
}
.news {
  background: url(https://static-ssl.aijiehu.cn/journalism.png) no-repeat;
  background-size: 100%;
  height: 660px;
  margin-top: 100px;
  position: relative;
}
.new_title {
  color: #ffffff;
  font-size: 28px;
  padding: 74px 0;
  font-weight: bold;
}
.news_com {
  position: absolute;
  top: 190px;
  padding: 0 15%;
}
.news_more {
  position: absolute;
  bottom: 70px;
  right: 306px;
  font-size: 24px;
}
.news_more a {
  color: #fff;
}
.contact_box {
  position: fixed;
  top: 200px;
  right: 0;
  z-index: 999;
}

.adv_con img {
  width: 24px;
  height: 9px;
  vertical-align: middle;
}
.adv_con1 img {
  width: 24px;
  height: 9px;
  margin-right: 6px;
  vertical-align: middle;
}

.el-carousel__item img {
  height: 750px;
  width: 100%;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue